import React from 'react'
import { Formik, Form, Field } from 'formik'
import { TextField } from 'formik-mui'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { navigate } from 'gatsby'
import {
    signInWithEmailAndPassword,
    sendPasswordResetEmail,
} from 'firebase/auth'
import { auth } from '../../../firebase-info'
import { Typography } from '@mui/material'
import ScrollDialog from '../modal/scroll-dialog'

const formStyle = {
    width: '100%',
    textAlign: 'center',
}

const inputStyle = {
    width: '90%',
}

const Login = (props) => {
    const [showResetPasswordDialog, setShowResetPasswordDialog] =
        React.useState(false)

    const performLogin = async (values, actions) => {
        try {
            await signInWithEmailAndPassword(
                auth,
                values.email,
                values.password
            )

            props.closePopover()
            navigate('/neighbour/dashboard/announces/')
        } catch (e) {
            const errorCode = e.code
            const errorMessage =
                errorCode === 'auth/invalid-credential'
                    ? 'Las credenciales no son correctas, si has olvidado tu contraseña, pulsa "Olvidé mi contraseña"'
                    : 'Ha ocurrido un problema, por favor, inténtalo más tarde.'
            actions.setSubmitting(false)
            await actions.setFieldValue('password', '')
            await actions.setFieldTouched('password')
            await actions.setFieldError('password', errorMessage)
        }
    }

    const sendResetPassword = (email) => {
        sendPasswordResetEmail(auth, email)
        setShowResetPasswordDialog(false)
    }

    const validateRegister = (values) => {
        const errors = {}

        if (!values.email) {
            errors.email = 'Obligatorio'
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
        ) {
            errors.email = 'esto no parece una dirección de email correcta'
        }
        if (!values.password) {
            errors.password = 'Obligatorio'
        }

        return errors
    }

    return (
        <Formik
            initialValues={{
                email: '',
                password: '',
            }}
            onSubmit={(values, actions) => {
                performLogin(values, actions)
            }}
            validate={(values) => {
                return validateRegister(values)
            }}
        >
            {({
                values,
                submitForm,
                isSubmitting,
                validateForm,
                setFieldTouched,
            }) => (
                <Form style={formStyle}>
                    <ScrollDialog
                        open={showResetPasswordDialog}
                        handleConfirm={() => sendResetPassword(values.email)}
                        handleClose={() => setShowResetPasswordDialog(false)}
                        title="Reestablecer contraseña"
                        content={
                            <>
                                <Typography>{`Enviaremos un correo a ${values.email} para reestablecer tu contraseña. ¿Deseas continuar?`}</Typography>
                                <Typography>{`Si no recibe el email, compruebe su carpeta de Spam.`}</Typography>
                            </>
                        }
                    />
                    <Box margin={1}>
                        <Field
                            component={TextField}
                            style={inputStyle}
                            name="email"
                            type="email"
                            label={'Email'}
                        />
                    </Box>
                    <Box margin={1}>
                        <Field
                            component={TextField}
                            style={inputStyle}
                            name="password"
                            type="password"
                            label={'Contraseña'}
                        />
                    </Box>
                    <Box margin={1}>
                        <Button
                            sx={{ m: 1 }}
                            variant="contained"
                            size="large"
                            color="primary"
                            disabled={isSubmitting}
                            onClick={submitForm}
                        >
                            Iniciar sesión
                        </Button>
                    </Box>
                    <Box>
                        <Button
                            sx={{ m: 1 }}
                            variant="text"
                            size="small"
                            color="secondary"
                            disabled={isSubmitting}
                            onClick={async () => {
                                const errors = await validateForm(values)
                                if (!errors.email) {
                                    setShowResetPasswordDialog(true)
                                } else {
                                    setFieldTouched('email')
                                }
                            }}
                        >
                            Olvidé mi contraseña
                        </Button>
                    </Box>
                    <Box margin={1}>
                        <Typography>¿No tienes cuenta?</Typography>
                        <Button
                            sx={{ m: 1 }}
                            variant="contained"
                            size="large"
                            color="secondary"
                            disabled={isSubmitting}
                            onClick={() => {
                                props.closePopover()
                                navigate('/register')
                            }}
                        >
                            Registrate
                        </Button>
                    </Box>
                </Form>
            )}
        </Formik>
    )
}

export default Login
